import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative overflow-hidden bg-[#F7F3E9]',
    wrap: 'relative container pt-6.5 pb-6 lg:px-15 lg:pt-15 lg:pb-10',

    top: 'mb-9 flex items-center justify-center gap-4.75 md:mb-10 md:justify-start lg:mb-22 lg:gap-8',
    logoMain: 'h-auto max-w-21.25 flex-none lg:max-w-47.25',
    logos:
      'flex items-center gap-4 border-l-1 border-black pl-4.75 lg:gap-8 lg:pl-10',
    logo: 'h-auto max-h-5 w-auto max-w-16.25 flex-none lg:max-w-22.5',

    body: 'mb-7 max-w-full md:max-w-152',
    title:
      'max-w-[70%] text-[32px]/9 font-semibold md:flex md:max-w-113 md:items-end md:justify-items-start lg:max-w-148.5 lg:text-5xl lg:leading-[120%]',
    titleMain:
      'font-cormorant-garamond mt-3 inline-block h-10 rounded-[100px] bg-(--color-icon-star) pr-4 pl-4 text-4xl leading-[35px] font-normal italic lg:-mb-2 lg:ml-3 lg:h-15 lg:pr-5 lg:pl-5 lg:text-6xl lg:leading-[48px]',
    backPicture:
      'absolute -right-60 bottom-0 h-auto w-130 max-w-130 flex-none md:-right-20 lg:w-140 lg:max-w-140 xl:right-15 xl:w-170 xl:max-w-170',

    bottom:
      'relative flex flex-col pr-0 md:mt-16 lg:mt-[98px] xl:flex-row xl:items-center xl:justify-between',
    tags: 'md;gap-2 flex flex-row flex-wrap items-start gap-1 md:gap-2',
    tag: 'relative flex max-w-60 items-center overflow-hidden rounded-[100px] p-1 pr-5 lg:max-w-78 lg:min-w-69 lg:pr-4',
    tagBack:
      'absolute top-0 right-0 bottom-0 left-0 rounded-[100px] bg-[#E7DFDB99] blur-[3px] md:blur-[0]',
    tagIconWrap:
      'flex-center relative mr-3 h-13 w-13 flex-none rounded-full border-2 border-white bg-[#F7F3E9] lg:mr-4 lg:h-18 lg:w-18',
    tagIcon: 'h-9 w-9 lg:h-12 lg:w-12',
    tagName: 'relative text-sm lg:text-lg',
    link: 'link mb-7 ml-1.5 inline-flex items-center text-base font-semibold uppercase md:ml-0 xl:mb-0',
    linkArrow: 'flex-center h-10 w-10',
    linkArrowIcon: '',
    advertisingInformer:
      'absolute top-auto right-3 bottom-6 lg:top-5 lg:right-10 lg:bottom-auto',
    advertisingInformerContent: 'max-lg:-top-[46px]'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
